import "./assets/css/main.css";
import MenuContent from "./components/MenuContent";
import FooterContent from "./components/FooterContent";
import Layout from "./Layout";
import { AppRouter } from "./routes/AppRoutes";

function App() {
  return (
    <Layout>
      <MenuContent />
      <AppRouter />
      <FooterContent />
    </Layout>
  );
}

export default App;
